module.exports = __webpack_public_path__ + "static/how-card-green-660e8fd74ca70c0be91f904afc23962d.svg";